import { GET_SECONDARY_APPROVER, SET_SECONDARY_APPROVER } from "./SecondaryApproverType";

const getSecondaryApprover = () => ({
    type: GET_SECONDARY_APPROVER,
});

const setSecondaryApprover = (secondaryApproverList: any) => ({
    type: SET_SECONDARY_APPROVER,
    secondaryApproverList
});

export {
    getSecondaryApprover,
    setSecondaryApprover
}
